import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
})
export class ButtonComponent {
  @Input() status = 'primary';
  @Input() disabled = false;
  @Input() isProcessing = false;
  @Output() clicked = new EventEmitter();

  handleClick() {
    this.clicked.emit();
  }
}
